<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.inventory.dialog.title' | translate"
		id="inventory-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.inventory.dialog.form.symbol.label' | translate">
							<ins-input
								id="inventory-dialog-symbol"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.symbol"
								[placeholder]="'scenes.configuration.shared.inventory.dialog.form.symbol.placeholder' | translate"
								[sklValidate]="getValidationKey('symbol')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.inventory.dialog.form.name.label' | translate">
							<ins-input
								id="inventory-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.inventory.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="inventory-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="inventory-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
